import { render, staticRenderFns } from "./partsRowTable.vue?vue&type=template&id=2ba0b5c6&scoped=true&"
import script from "./partsRowTable.vue?vue&type=script&lang=js&"
export * from "./partsRowTable.vue?vue&type=script&lang=js&"
import style0 from "./partsRowTable.vue?vue&type=style&index=0&id=2ba0b5c6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba0b5c6",
  null
  
)

export default component.exports